import { NgClass } from '@angular/common';
import {
	Component,
	inject,
	input,
	output,
	ViewEncapsulation,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import type { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { RecaptchaNotificationComponent } from '@valk-nx/components/ui-recaptcha-notification/src/lib/recaptcha-notification';
import type { Language } from '@valk-nx/core/lib/core';
import { SharedFormlyModule } from '@valk-nx/formly/lib/formly.module';
import { GeneralHelper } from '@valk-nx/helpers/lib/general/general.helper';

import { form } from './form';

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'vp-newsletter',
	templateUrl: './newsletter.html',
	imports: [
		NgClass,
		RecaptchaNotificationComponent,
		SharedFormlyModule,
		TranslatePipe,
	],
})
export class NewsletterComponent {
	private readonly translate = inject(TranslateService);

	formFields = input<FormlyFieldConfig[]>(form);
	newsletterSubmitting = input<boolean>(false);
	newsletterSubmitError = input<boolean>(false);
	newsletterSubmitted = input<boolean>(false);

	formSubmit = output<[string, string?]>();

	language: Language;

	formGroup = new FormGroup({
		email: new FormControl('', Validators.required),
	});

	constructor() {
		this.language = (this.translate.getCurrentLang() ??
			this.translate.getFallbackLang()) as Language;
	}

	onSubmit(): void {
		if (this.formGroup.valid && this.formGroup.value['email']) {
			this.formSubmit.emit([
				this.formGroup.value['email'],
				this.formGroup.get('recaptcha')?.value,
			]);

			if (
				!GeneralHelper.isIdElementInsideViewport(
					'newsletter-submit',
					44,
				)
			) {
				GeneralHelper.scrollToElementWithId('newsletter-submit', 44);
			}
		}
	}
}
